import { render, staticRenderFns } from "./warning-letter.vue?vue&type=template&id=76756f60"
import script from "./warning-letter.vue?vue&type=script&lang=js"
export * from "./warning-letter.vue?vue&type=script&lang=js"
import style0 from "./warning-letter.vue?vue&type=style&index=0&id=76756f60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports